import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <div className="min-h-screen bg-[#f0f2ee] flex items-center justify-center p-6">
      <div className="text-center">
        <div className="text-9xl font-bold text-slate-200">404</div>
        <h1 className="text-2xl font-semibold text-slate-800 mt-4">Page Not Found</h1>
        <p className="text-slate-500 mt-2">The page you're looking for doesn't exist or has been moved.</p>
        <Link
          to="/"
          className="inline-flex items-center justify-center mt-6 px-6 py-2.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}